import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2362b402"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "second-routerView flex f-d" }
const _hoisted_2 = { class: "statistical-data" }
const _hoisted_3 = {
  class: "display-data flex j-s a-c",
  style: {"position":"relative"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "data-num" }
const _hoisted_6 = { class: "data-type" }
const _hoisted_7 = {
  key: 0,
  style: {"width":"1rem","height":"1rem","border-radius":"0.5rem","background-color":"#f9553c","position":"absolute","right":"-0.2rem","top":"-0.2rem"}
}
const _hoisted_8 = { class: "dispose flex f-d j-s-b" }
const _hoisted_9 = { class: "dispose-need" }
const _hoisted_10 = {
  key: 0,
  class: "chooseTp flex f-d"
}
const _hoisted_11 = { class: "choosePrech" }
const _hoisted_12 = { class: "choose-type-content flex" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "content-right flex j-s-b" }
const _hoisted_15 = { class: "title-time" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "time" }
const _hoisted_18 = { style: {"display":"flex","gap":"20px"} }
const _hoisted_19 = {
  key: 0,
  style: {"margin-top":"2rem","background-color":"#f9553c","width":"2rem","height":"2rem","text-align":"center","line-height":"2rem","color":"#fff","border-radius":"1rem"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "dispose-type flex f-d"
}
const _hoisted_27 = {
  key: 0,
  style: {"padding-bottom":"50px"}
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  class: "img",
  style: {"position":"relative"}
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 0,
  style: {"width":"1rem","height":"1rem","border-radius":"0.5rem","background-color":"#f9553c","position":"absolute","right":"-0.2rem","top":"-0.2rem"}
}
const _hoisted_32 = { class: "case-type flex f-d j-s-e" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "need-num" }
const _hoisted_35 = {
  key: 1,
  class: "no-connect"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer" }, " 沪ICP备18031871号-1 Copyright ©2016-2024 上海共为信息技术有限公司 ︱ 地址：上海市闵行区江凯路199号 ", -1))

import NotYetOpen from "@/components/NotYetOpen.vue";
import { computed, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import UserTools from "@/services/session/UserTools";
import { ArrowRight } from "@element-plus/icons-vue";
// 图片前缀
import imgConstant from "../../config/img";
import { ServiceStatsItem } from "@/services/datatype/business/service/stats/ServiceStatsItem";
import { EnterpriseServiceRequestInfo } from "@/services/datatype/business/service/request/EnterpriseServiceRequestInfo";
import { DateFormat, FORMAT_TYPE } from "@/services/util/DateFormat";
import { RequestStatusClassifierUtils } from "@/services/datatype/request/RequestStatusClassifierUtils";
import { useStore } from "vuex";
import Paging from "@/components/Layout/paging.vue";
import PageUtils from "@/utils/PageUtils";
import { useRouter } from "vue-router";
import MessageUtil from "@/utils/Message";
import PerchUtil from "@/utils/Perch";
import order from "@/api/order";
import { RequestStatusType } from "@/services/datatype/request/RequestStatusType";

interface DataList {
  num: string | number;
  type: string;
  unreadMessageCountByWorker: number;
}

interface Bread {
  orderType: string;
  orderState: string;
  orderId: string | number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const radio3 = ref("客服请求");
const router = useRouter();

const data = reactive({
  propsData: [],
  data: [],
});
const getData: (x: any[]) => void = (x: any[]): void => {
  console.log(79998888);
  data.data = x;
  PerchUtil.Perch(
    pageSize.value,
    data.data.length,
    ".choose-type",
    ".choosePrech"
  );
};
const $store = useStore();
console.log(UserTools.userRoles.roles);
let currentRole = UserTools.userRoles.roles[$store.state.currentRole.roleIndex];
const isCustomer = ref<boolean>(
  currentRole.enterpriseInfo.enterpriseType == 29
);
let entityServiceStats: any = reactive({});
let dataList: DataList[] = reactive([]);
// 待处理已处理menu高亮
const activeIndex = ref<number>(0);
// 待处理已处理menu高亮下数据高亮
const activeEnterpriseServiceRequestIndex = ref<number>(0);
const activeEnterpriseServiceRequestNum = ref<number>(0);
// 案件类型分类例如合同修改法律咨询 '2023-03-23 16:58'
let statsItems = ref<ServiceStatsItem[]>([]);
// needStatusCategories 与 needList 相对应
const needStatusCategories =
  RequestStatusClassifierUtils.getDisplayableRequestStatusClassifiers();
const needList = reactive(
  RequestStatusClassifierUtils.getDisplayableRequestStatusClassifierFullNames()
);
let bread: Bread = reactive({
  orderType: "",
  orderState: "",
  orderId: "",
});
const breadState = ref<boolean>(false);
const needState = ref<boolean>(false);

// 待处理接受
const accept = (item: EnterpriseServiceRequestInfo): void => {
  loadStatsItems(activeEnterpriseServiceRequestIndex.value);
  order.acceptOrder(Number(item.rid as string));
  loadEnterpriseServiceRequestList(activeEnterpriseServiceRequestIndex.value);
  getList();
  toTalk(item.rid);
};
const handle = (item: EnterpriseServiceRequestInfo): void => {
  loadStatsItems(activeEnterpriseServiceRequestIndex.value);
  DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseServiceRequestService()
    .acceptDelegateByServiceWorker(item.rid);
  loadEnterpriseServiceRequestList(activeEnterpriseServiceRequestIndex.value);
  getList();
  toTalk(item.rid);
};

const toTalk = (id: number | string) => {
  router.push({
    path: "/layout/talk",
    query: {
      rid: id,
      code: "true",
      breadType: "0",
      title: bread.orderState,
      type: radio3.value,
      index: activeEnterpriseServiceRequestIndex.value,
      num: data.propsData.length,
    },
  });
};

// 待处理拒绝
const refuse = (item: EnterpriseServiceRequestInfo) => {
  order.refuseOrder(Number(item.rid as string));
  if (data.data.length === 1) {
    data.data = [];
    breadState.value = false;
    needState.value = false;
  }
  getList();
};
// 跳转聊天页面
// 获取统计数据
const getList = async (): Promise<void> => {
  let entityStatsPromise;
  setTimeout(async () => {
    if (currentRole.enterpriseInfo.enterpriseType === 29) {
      if (radio3.value === "客服请求") {
        entityStatsPromise = DefaultWebServiceFactory.getInstance()
          .getWebEnterpriseServiceRequestService()
          .getCustomerServiceStats(UserTools.entityInfo.entityId);
      } else {
        entityStatsPromise = DefaultWebServiceFactory.getInstance()
          .getWebEnterpriseServiceRequestService()
          .getCustomerServiceMonitorStats(UserTools.entityInfo.entityId);
      }
    } else {
      entityStatsPromise = DefaultWebServiceFactory.getInstance()
        .getWebEnterpriseServiceRequestService()
        .getServingEntityServiceStats(UserTools.entityInfo.entityId);
    }
    await entityStatsPromise.then((t) => {
      console.log(t, 888666669999);
      entityServiceStats = t;
      getdataList(t);
      loadStatsItems(activeIndex.value);
      loadEnterpriseServiceRequestList(
        activeEnterpriseServiceRequestIndex.value
      );
      if (router.currentRoute.value.query.key) {
        bread.orderType = router.currentRoute.value.query.text as string;
        bread.orderState = router.currentRoute.value.query.title as string;
        let _statsItems = entityServiceStats.getStatsItemsByStatusClassifier(
          needStatusCategories[activeIndex.value]
        );
        const statsItems = _statsItems.find(
          (statsItems) =>
            statsItems.serviceType == router.currentRoute.value.query.key
        );
        const index = _statsItems.findIndex(
          (statsItems) =>
            statsItems.serviceType == router.currentRoute.value.query.key
        );
        if (statsItems) {
          openServiceRequestList(
            index,
            statsItems.getDescription(),
            activeIndex.value == 0
              ? statsItems.totalAssignedRequests
              : activeIndex.value == 1
              ? statsItems.totalAcceptedRequests
              : statsItems.totalCompletedRequests
          );
        }
      }
    });
  }, 700);
};
const getdataList = (t) => {
  dataList.splice(0, dataList.length);
  needList.forEach((r, i) => {
    let count = 0;
    let unreadMessageCountByWorker = 0;
    if (t.getStatsItemsByStatusClassifier(needStatusCategories[i])) {
      t.getStatsItemsByStatusClassifier(needStatusCategories[i])?.forEach(
        (j) => {
          if (currentRole.enterpriseInfo.enterpriseType === 29) {
            if (radio3.value === "客服请求") {
              DefaultWebServiceFactory.getInstance()
                .getWebEnterpriseServiceRequestService()
                .findClassifiedCustomerServiceRequestsByCustomerServiceWorker(
                  UserTools.loginId,
                  j?.serviceClassifier,
                  needStatusCategories[i],
                  PageUtils.getNewPageBlockAccessSpec(
                    6,
                    Math.ceil(total.value / 6)
                  )
                )
                .then((items: any) => {
                  for (const item of items.pageData) {
                    if (item.unreadMessageCountByWorker) {
                      unreadMessageCountByWorker +=
                        item.unreadMessageCountByWorker;
                    }
                  }
                  dataList[i].unreadMessageCountByWorker =
                    unreadMessageCountByWorker;
                });
            } else {
              DefaultWebServiceFactory.getInstance()
                .getWebEnterpriseServiceRequestService()
                .findClassifiedEnterpriseServiceRequestsByCustomerService(
                  UserTools.loginId,
                  j?.serviceClassifier,
                  needStatusCategories[i],
                  PageUtils.getNewPageBlockAccessSpec(
                    6,
                    Math.ceil(total.value / 6)
                  )
                )
                .then((items: any) => {
                  for (const item of items.pageData) {
                    if (item.unreadMessageCountByWorker) {
                      unreadMessageCountByWorker +=
                        item.unreadMessageCountByWorker;
                    }
                  }
                  dataList[i].unreadMessageCountByWorker =
                    unreadMessageCountByWorker;
                });
            }
          } else {
            DefaultWebServiceFactory.getInstance()
              .getWebEnterpriseServiceRequestService()
              .findClassifiedEnterpriseServiceRequestsByServingEntity(
                UserTools.loginId,
                j?.serviceClassifier,
                needStatusCategories[i],
                PageUtils.getNewPageBlockAccessSpec(
                  6,
                  Math.ceil(total.value / 6)
                )
              )
              .then((items: any) => {
                for (const item of items.pageData) {
                  if (item.unreadMessageCountByWorker) {
                    unreadMessageCountByWorker +=
                      item.unreadMessageCountByWorker;
                  }
                }
                dataList[i].unreadMessageCountByWorker =
                  unreadMessageCountByWorker;
              });
          }
          i == 0
            ? (count += Number(j.totalAssignedRequests))
            : i == 1
            ? (count += Number(j.totalAcceptedRequests))
            : (count += Number(j.totalCompletedRequests));
        }
      );
    }
    dataList.push({
      num: count,
      type: r,
      unreadMessageCountByWorker: unreadMessageCountByWorker,
    });
  });
};
// 获取menu下需求种类
const loadStatsItems = (index: number = activeIndex.value): void => {
  data.propsData.splice(0, data.propsData.length);
  data.data.splice(0, data.data.length);
  if (entityServiceStats) {
    let _statsItems = entityServiceStats.getStatsItemsByStatusClassifier(
      needStatusCategories[index]
    );
    statsItems.value = [];
    for (const ServiceStatsItem of _statsItems) {
      ServiceStatsItem.unreadRequestCountByWorker = 0;
      if (currentRole.enterpriseInfo.enterpriseType === 29) {
        if (radio3.value === "客服请求") {
          DefaultWebServiceFactory.getInstance()
            .getWebEnterpriseServiceRequestService()
            .findClassifiedCustomerServiceRequestsByCustomerServiceWorker(
              UserTools.loginId,
              ServiceStatsItem?.serviceClassifier,
              needStatusCategories[index],
              PageUtils.getNewPageBlockAccessSpec(6, Math.ceil(total.value / 6))
            )
            .then((items: any) => {
              console.log(items, 444444444);
              for (const item of items.pageData) {
                if (item.unreadMessageCountByWorker) {
                  ServiceStatsItem.unreadRequestCountByWorker +=
                    item.unreadMessageCountByWorker;
                }
              }
              statsItems.value = [..._statsItems];
              console.log(statsItems.value, 7788899996666);
            });
        } else {
          DefaultWebServiceFactory.getInstance()
            .getWebEnterpriseServiceRequestService()
            .findClassifiedEnterpriseServiceRequestsByCustomerService(
              UserTools.loginId,
              ServiceStatsItem?.serviceClassifier,
              needStatusCategories[index],
              PageUtils.getNewPageBlockAccessSpec(6, Math.ceil(total.value / 6))
            )
            .then((items: any) => {
              for (const item of items.pageData) {
                if (item.unreadMessageCountByWorker) {
                  ServiceStatsItem.unreadRequestCountByWorker +=
                    item.unreadMessageCountByWorker;
                }
              }
              statsItems.value = [..._statsItems];
            });
        }
      } else {
        DefaultWebServiceFactory.getInstance()
          .getWebEnterpriseServiceRequestService()
          .findClassifiedEnterpriseServiceRequestsByServingEntity(
            UserTools.loginId,
            ServiceStatsItem?.serviceClassifier,
            needStatusCategories[index],
            PageUtils.getNewPageBlockAccessSpec(6, Math.ceil(total.value / 6))
          )
          .then((items: any) => {
            for (const item of items.pageData) {
              if (item.unreadMessageCountByWorker) {
                ServiceStatsItem.unreadRequestCountByWorker +=
                  item.unreadMessageCountByWorker;
              }
            }
            statsItems.value = [..._statsItems];
          });
      }
      statsItems.value = [..._statsItems];
    }
  }
};
// 切换方法、ep中的menu
const handleSelect = (key: number): void => {
  breadState.value = false;
  needState.value = false;
  activeIndex.value = key;
  loadStatsItems(activeIndex.value);
};
// const chooseIndex = ref<number>(0)
const pageIndex = ref<number>(1);
const total = ref<number>(0);
const totalPage = ref<number>(0);
const pageSize = ref<number>(6);
// 点击menu 下方分类 ，进入bread和bread下具体需求
const openServiceRequestList = (
  index: number,
  need: string,
  num: number
): void => {
  activeEnterpriseServiceRequestIndex.value = index;
  breadState.value = true;
  needState.value = true;
  bread.orderType = needList[Number(activeIndex.value)];
  bread.orderState = need;
  bread.orderId = "";
  // chooseIndex.value = index
  pageIndex.value = 1;
  total.value = num;
  totalPage.value = Math.ceil(total.value / pageSize.value);
  loadEnterpriseServiceRequestList(index);
};
// 加载需求
const loadEnterpriseServiceRequestList = (index: number): void => {
  isCustomer.value = currentRole.enterpriseInfo.enterpriseType == 29;
  if (statsItems.value) {
    if (currentRole.enterpriseInfo.enterpriseType === 29) {
      if (radio3.value === "客服请求") {
        console.log(statsItems.value[index]?.getServiceType(), 8999);
        console.log(needStatusCategories[activeIndex.value], 8999);
        DefaultWebServiceFactory.getInstance()
          .getWebEnterpriseServiceRequestService()
          .findClassifiedCustomerServiceRequestsByCustomerServiceWorker(
            UserTools.loginId,
            statsItems.value[index]?.getServiceClassifier(),
            needStatusCategories[activeIndex.value],
            PageUtils.getNewPageBlockAccessSpec(6, Math.ceil(total.value / 6))
          )
          .then((items) => {
            data.propsData.splice(0, data.propsData.length);
            let arr = [...items.getPageData()].splice(
              (pageIndex.value - 1) * pageSize.value,
              [...items.getPageData()].length
            );
            arr.forEach((r) => {
              if (r.imageUrls) {
                r.imageUrls[0] = r.imageUrls[0].trim();
                r.servingEnterpriseInfo.logoImgUrl = r.servingEnterpriseInfo
                  .logoImgUrl
                  ? imgConstant + r.servingEnterpriseInfo.logoImgUrl.trim()
                  : "https://img0.baidu.com/it/u=2260184878,3804521724&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500";
              } else {
                r.imageUrls = [statsItems.value[index]?.imgUrl];
              }
              if (!r.tradeTitle) {
                r.tradeTitle = statsItems.value[index]?.getDescription();
              }
              r.createTime = DateFormat.dateFormatString(
                Number(r.createTime),
                FORMAT_TYPE.NORMAL3
              );
              data.propsData.push(r);
            });
            data.propsData.sort((a, b) => {
              return (
                (b.unreadMessageCountByWorker || 0) -
                (a.unreadMessageCountByWorker || 0)
              );
            });
          });
      } else {
        DefaultWebServiceFactory.getInstance()
          .getWebEnterpriseServiceRequestService()
          .findClassifiedEnterpriseServiceRequestsByCustomerService(
            UserTools.loginId,
            statsItems.value[index]?.getServiceClassifier(),
            needStatusCategories[activeIndex.value],
            PageUtils.getNewPageBlockAccessSpec(6, Math.ceil(total.value / 6))
          )
          .then((items) => {
            data.propsData.splice(0, data.propsData.length);
            let arr = [...items.getPageData()].splice(
              (pageIndex.value - 1) * pageSize.value,
              [...items.getPageData()].length
            );
            arr.forEach((r) => {
              if (r.imageUrls) {
                r.imageUrls[0] = r.imageUrls[0].trim();
                r.servingEnterpriseInfo.logoImgUrl = r.servingEnterpriseInfo
                  .logoImgUrl
                  ? imgConstant + r.servingEnterpriseInfo.logoImgUrl.trim()
                  : "https://img0.baidu.com/it/u=2260184878,3804521724&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500";
              } else {
                r.imageUrls = [statsItems.value[index]?.imgUrl];
              }
              if (!r.tradeTitle) {
                r.tradeTitle = statsItems.value[index]?.getDescription();
              }
              r.createTime = DateFormat.dateFormatString(
                Number(r.createTime),
                FORMAT_TYPE.NORMAL3
              );
              data.propsData.push(r);
            });
            data.propsData.sort((a, b) => {
              return (
                (b.unreadMessageCountByWorker || 0) -
                (a.unreadMessageCountByWorker || 0)
              );
            });
          });
      }
    } else {
      DefaultWebServiceFactory.getInstance()
        .getWebEnterpriseServiceRequestService()
        .findClassifiedEnterpriseServiceRequestsByServingEntity(
          UserTools.loginId,
          statsItems.value[index]?.getServiceClassifier(),
          needStatusCategories[activeIndex.value],
          PageUtils.getNewPageBlockAccessSpec(6, Math.ceil(total.value / 6))
        )
        .then((items) => {
          data.propsData.splice(0, data.propsData.length);
          let arr = [...items.getPageData()].splice(
            (pageIndex.value - 1) * pageSize.value,
            [...items.getPageData()].length
          );
          arr.forEach((r) => {
            r.imageUrls[0] = r.imageUrls[0].trim();
            r.servingEnterpriseInfo.logoImgUrl = r.servingEnterpriseInfo
              .logoImgUrl
              ? imgConstant + r.servingEnterpriseInfo.logoImgUrl.trim()
              : "https://img0.baidu.com/it/u=2260184878,3804521724&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500";
            r.createTime = DateFormat.dateFormatString(
              Number(r.createTime),
              FORMAT_TYPE.NORMAL3
            );
            data.propsData.push(r);
          });
          data.propsData.sort((a, b) => {
            return (
              (b.unreadMessageCountByWorker || 0) -
              (a.unreadMessageCountByWorker || 0)
            );
          });
        });
    }
  }
};
// 用于拦截浏览器回退
const goBack = () => {
  if (breadState.value == true && needState.value == true) {
    breadState.value = false;
    needState.value = false;
    history.pushState(null, null, document.URL);
    loadStatsItems(activeIndex.value);
    getList();
  } else {
    window.history.back();
  }
};
const roleIndex = computed(() => {
  //返回的是ref对象
  return $store.state.currentRole.roleIndex;
});
watch(roleIndex, (newVal) => {
  currentRole = UserTools.userRoles.roles[newVal];
  getList();
});
watch(radio3, () => {
  localStorage.setItem("radio", radio3.value);
  getList();
});
onMounted(() => {
  currentRole =
    UserTools.userRoles.roles[localStorage.getItem("userRoleIndex") || 0];
  if (router.currentRoute.value.query.key) {
    bread.orderType = router.currentRoute.value.query.text as string;
    bread.orderState = router.currentRoute.value.query.title as string;
    breadState.value = true;
    needState.value = true;
  }
  activeIndex.value = Number(router.currentRoute.value.query.index || 0);
  getList();
  if (router.currentRoute.value.query._index) {
    openServiceRequestList(
      router.currentRoute.value.query._index,
      router.currentRoute.value.query.title,
      router.currentRoute.value.query._num
    );
  }
  MessageUtil.getMessage(null, getList);
  setInterval(() => {
    getList();
    MessageUtil.getMessage(null, getList);
  }, 20000);
  if (window.history && window.history.pushState) {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", goBack, false);
  }
});
watch(radio3, () => {
  breadState.value = false;
  needState.value = false;
});
onUnmounted(() => {
  window.removeEventListener("popstate", goBack, false);
});

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(currentRole).enterpriseInfo.enterpriseType === 29)
            ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 0,
                style: {"position":"absolute","top":"0.5rem","right":"1.5rem"},
                modelValue: radio3.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radio3).value = $event)),
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, {
                    label: "客服请求",
                    value: "客服请求"
                  }),
                  _createVNode(_component_el_radio_button, {
                    label: "服务监管",
                    value: "服务监管"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "display flex f-d j-c a-c",
              onClick: ($event: any) => (handleSelect(index)),
              key: index
            }, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(item.num), 1),
              _createElementVNode("h2", _hoisted_6, _toDisplayString(item.type), 1),
              (
              (item.num > 0 && item.type == '待处理需求') ||
              (item.type == '处理中需求' &&
                item.unreadMessageCountByWorker &&
                item.unreadMessageCountByWorker > 0)
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(activeIndex.value == index ? 'bottom' : '')
              }, null, 2)
            ], 8, _hoisted_4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (breadState.value)
            ? (_openBlock(), _createBlock(_component_el_breadcrumb, {
                key: 0,
                "separator-icon": _unref(ArrowRight)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_breadcrumb_item, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
              (needState.value = false),
                (breadState.value = false),
                _unref(router).replace({
                  path: '/layout/home',
                }),
                loadStatsItems()
            ))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(bread).orderType), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(bread).orderState), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(bread).orderId), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["separator-icon"]))
            : _createCommentVNode("", true)
        ]),
        (needState.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "choose-type",
                    key: item.rid
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: 
                  item.imageUrls[0]
                    ? _unref(imgConstant) + item.imageUrls[0]
                    : '/assets/12' + '.jpg'
                ,
                        alt: ""
                      }, null, 8, _hoisted_13),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("h2", _hoisted_16, _toDisplayString(item.serviceTypeDisplayName +
                      "(" +
                      item.initiatorInfo.entityName +
                      ")" +
                      item.rid +
                      (isCustomer.value
                        ? "(" + (item.preSale ? "售前" : "售后") + ")"
                        : "")), 1),
                          _createElementVNode("p", _hoisted_17, "发起时间： " + _toDisplayString(item.createTime), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          (
                      (activeIndex.value == 1 &&
                        item.unreadMessageCountByWorker &&
                        item.unreadMessageCountByWorker > 0) ||
                      activeIndex.value == 0
                    )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(activeIndex.value == 0
                        ? ""
                        : item.unreadMessageCountByWorker > 99
                        ? "99+"
                        : item.unreadMessageCountByWorker), 1))
                            : _createCommentVNode("", true),
                          (activeIndex.value == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (item.status != _unref(RequestStatusType).ACCEPTED)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => (accept(item))
                                    }, " 接受 ", 8, _hoisted_21))
                                  : _createCommentVNode("", true),
                                (item.status != _unref(RequestStatusType).ACCEPTED)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: ($event: any) => (refuse(item))
                                    }, " 拒绝 ", 8, _hoisted_22))
                                  : _createCommentVNode("", true),
                                (item.status == _unref(RequestStatusType).ACCEPTED)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      onClick: ($event: any) => (handle(item))
                                    }, " 处理 ", 8, _hoisted_23))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (activeIndex.value == 1)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                onClick: ($event: any) => (toTalk(item.rid, item.serviceTypeDisplayName))
                              }, " 去处理 ", 8, _hoisted_24))
                            : _createCommentVNode("", true),
                          (activeIndex.value == 2)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                onClick: ($event: any) => (toTalk(item.rid, item.serviceTypeDisplayName))
                              }, " 去查看 ", 8, _hoisted_25))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode(Paging, {
                data: data.propsData,
                "page-size": pageSize.value,
                onGetData: getData
              }, null, 8, ["data", "page-size"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_unref(statsItems) && _unref(statsItems).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statsItems), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "type flex j-c-s a-c",
                        key: item.serviceType,
                        onClick: ($event: any) => (
              openServiceRequestList(
                index,
                item.serviceClassifierDisplayName,
                item.totalAssignedRequests
              )
            )
                      }, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("img", {
                            src: 
                  item.imgUrl
                    ? _unref(imgConstant) + item.imgUrl
                    : '/assets/12' + '.jpg'
                ,
                            alt: ""
                          }, null, 8, _hoisted_30),
                          (
                  (item.totalAssignedRequests > 0 && activeIndex.value == 0) ||
                  (activeIndex.value == 1 &&
                    item.unreadRequestCountByWorker &&
                    item.unreadRequestCountByWorker > 0)
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("h2", null, _toDisplayString(item.serviceClassifierDisplayName), 1),
                          (item.latestRequestTime)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, " 发起时间： " + _toDisplayString(item.latestRequestTime
                    ? _unref(DateFormat).dateFormatString(
                        Number(item.latestRequestTime),
                        _unref(FORMAT_TYPE).NORMAL3
                      )
                    : ""), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("h2", null, _toDisplayString(activeIndex.value == "0"
                    ? item.totalAssignedRequests
                    : activeIndex.value == "1"
                    ? item.totalAcceptedRequests
                    : item.totalCompletedRequests) + "个需求> ", 1)
                        ])
                      ], 8, _hoisted_28))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(NotYetOpen, { data: "暂无内容哦!" })
                  ]))
            ]))
      ])
    ]),
    _hoisted_36
  ], 64))
}
}

})